import { Component } from '@angular/core';

import { SkyModalService } from '../../core';

import { SkyWizardDemoFormComponent } from './wizard-demo-form.component';


export class SkyWizardDemoComponent {
  constructor(private modal: SkyModalService) { }

  public openWizard() {
    this.modal.open(SkyWizardDemoFormComponent);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-wizard-demo',
  template: `<button
  type="button"
  class="sky-btn sky-btn-default"
  (click)="openWizard()">
  Open wizard
</button>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyModalService, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
